/**
 * NPC·상점 테이블. 수치는 `npcs.json`.
 */

import seed from './npcs.json';
import { emitDataReloadSoon, replaceRecord, requireRecord } from './catalog';

export interface NpcDef {
  id: string;
  name: string;
  title: string;
  tint: number;
  lines: readonly string[];
  questIds?: readonly string[];
  shopId?: string;
  jobAdvance?: boolean;
}

export interface ShopDef {
  id: string;
  buyMul: number;
  stock: readonly string[];
}

export const NPCS: Record<string, NpcDef> = structuredClone(seed.NPCS) as Record<string, NpcDef>;
export const SHOPS: Record<string, ShopDef> = structuredClone(seed.SHOPS) as Record<string, ShopDef>;

export function getNpc(id: string): NpcDef | undefined {
  return NPCS[id];
}

export function getShop(id: string | undefined): ShopDef | undefined {
  if (!id) return undefined;
  return SHOPS[id];
}

export function applyNpcs(raw: unknown): void {
  const data = requireRecord(raw, 'npcs.json');
  replaceRecord(NPCS, structuredClone(requireRecord(data.NPCS, 'NPCS')) as Record<string, NpcDef>);
  replaceRecord(SHOPS, structuredClone(requireRecord(data.SHOPS, 'SHOPS')) as Record<string, ShopDef>);
}

if (import.meta.hot) {
  import.meta.hot.accept('./npcs.json', (mod) => {
    if (!mod?.default) return;
    applyNpcs(mod.default);
    emitDataReloadSoon();
  });
}
